<mat-form-field
  [appearance]="appearance"
  class="w-full"
  [floatLabel]="!control?.value ? 'always' : 'auto'"
>
  <mat-label [attr.for]="id">{{ label }}</mat-label>
  <textarea
    matInput
    [formControl]="control"
    [attr.id]="id"
    [attr.name]="name"
    [placeholder]="placeholder"
    [rows]="rows || 5"
    autocomplete="on"
  ></textarea>
</mat-form-field>
<mat-error siatErrorField [control]="control" [label]="label"></mat-error>
